<div *ngIf="form" [formGroup]="form" class="venue-customer-facilities-fields">
  <div class="venue-customer-facilities-fields__head">
    <a
      class="venue-customer-facilities-fields__toggle"
      role="button"
      tabindex="0"
      (click)="toggleFacilities()"
      (keydown.enter)="toggleFacilities()"
      (keydown.space)="$event.preventDefault(); toggleFacilities()">
      <p class="venue-customer-facilities-fields__title ui-input__placeholder m-0">
        Условия и возможности площадки
        <span class="require" *ngIf="layout === 'signUp'">*</span>
      </p>
      <span
        class="venue-customer-facilities-fields__chevron"
        [class.venue-customer-facilities-fields__chevron--expanded]="facilitiesExpanded"></span>
    </a>
  </div>
  <div *ngIf="facilitiesExpanded" [ngClass]="layout === 'dialog' ? 'profile-individual-customer-dialog__social-list' : ''">
    <div
      *ngFor="let key of FacilityOptionKeys"
      class="venue-customer-facilities-fields__facility-row mb-2"
      [ngClass]="layout === 'signUp' ? 'grid align-items-start' : 'profile-individual-customer-dialog__row'">
      <div
        [ngClass]="
          layout === 'signUp' ? 'col-6 col-sm-12 no-padding' : 'profile-individual-customer-dialog__cell'
        ">
        <div
          [ngClass]="{
            'sign-up__forms-input': layout === 'signUp',
            'pr-4': layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile
          }">
          <div class="ui-input__placeholder">
            <p>{{ facilityLabel(key) }}</p>
          </div>
          <p-dropdown
            [options]="FacilitySupportLevels"
            optionLabel="name"
            optionValue="value"
            [formControlName]="'facility_' + key + '_level'"
            placeholder="Не выбрано"
            styleClass="p-dropdown__bulletins w-full">
          </p-dropdown>
        </div>
      </div>
      <div
        [ngClass]="
          layout === 'signUp' ? 'col-6 col-sm-12 no-padding' : 'profile-individual-customer-dialog__cell'
        ">
        <div
          [ngClass]="{
            'sign-up__forms-input': layout === 'signUp',
            'pl-4': layout === 'signUp' && (deviceValue | async) !== DTypes.Mobile
          }">
          <div class="ui-input__placeholder">
            <p>Комментарий</p>
          </div>
          <div class="ui-input ui-input__text venue-customer-facilities-fields__notes-field">
            <textarea
              [formControlName]="'facility_' + key + '_notes'"
              placeholder='Например: "только по выходным"'
              maxlength="50"
              rows="1"></textarea>
          </div>
          <p class="pt-1 txt-helper">Доступно символов для ввода: {{ facilityCommentLimit(key) }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
